import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PrintData from "components/GenericComponent/PrintData";
import {PrintDataContent} from "../../components/GenericComponent/PrintDataContent";
import configs from "constants/configs";
import { Cookies } from "react-cookie";
export const BtnInDanhSach = ({ dataSearch }) => {

    let {
        dateTo,
        code,
        customerName,
        address,
        debt,
        userName,
        trangThaiGiaHan,
        kieuvay,
        tienVay,
        typeNgayPhaiTra,
        optionDateMB,
        sapxep,
    } = dataSearch;
  const cookies = new Cookies();
  let link = configs.endPoint;
  var apilink = cookies.get("apilink");
  if (typeof apilink != "undefined" && apilink.length > 0) {
    link = apilink;
  }
  link = link +
    `quanlychovay/no-phai-thu-in-data?tenKhachHang=${customerName}&kieuvay=${kieuvay}&tienVay=${tienVay}&maTaiSan=${code}&user=${userName}&debtLevel=${debt}&trangThaiGiaHan=${trangThaiGiaHan}&diaChi=${address}&denNgay=${dateTo}&typeNgayPhaiTra=${typeNgayPhaiTra}&sapxep=${sapxep}&optionDateMB=${optionDateMB}`;
  return (
    <>
      <PrintDataContent link={link} loai={"NoPhaiThuPrint"} />
    </>
  );
};
